import { Field } from '@common/general-ui/field/field.component';
import { Readonly } from '@common/general-ui/readonly.component';
import { Input as AntdInput } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IInputProps, inputStyles } from './input.component';

export const InputNumber = (props: IInputProps): JSX.Element => {
    const { size, errorMessage, helperText, value, validate: registerOptions, ...rest } = props;

    const [val, setVal] = useState(props.defaultValue || props.value);
    useEffect(() => {
        if (props.value !== undefined) {
            setVal(props.value);
        }
    }, [props.value]);

    useEffect(() => {
        if (props.defaultValue !== undefined) {
            setVal(props.defaultValue);
        }
    }, [props.defaultValue]);

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            // eslint-disable-next-line no-useless-escape
            let newValueStr = e.target.value.replaceAll(/[^-0-9\.]/g, '');
            newValueStr = newValueStr.replaceAll(/--/g, '-');
            if (newValueStr.split('.').length > 2) {
                newValueStr = value?.toString() || '';
            }
            if (newValueStr === '.') {
                newValueStr = '';
            }

            setVal(newValueStr);
            props.onChange && props.onChange({ ...e, target: { ...e.target, value: newValueStr as unknown as string } });
        },
        [props, value],
    );

    const handleBlur = useCallback(
        (e: React.FocusEvent<HTMLInputElement>) => {
            props.onBlur && props.onBlur({ ...e, target: { ...e.target, value: e.target.value } });
        },
        [props],
    );

    const formatText = useMemo(() => {
        return val !== undefined ? `${val}` : '';
    }, [val]);

    return (
        <Field {...props}>
            <div tw="relative">
                {props.readOnly && <Readonly />}
                <AntdInput
                    {...rest}
                    prefix={props.prefix}
                    maxLength={props.maxLength}
                    tabIndex={props.readOnly ? -1 : 0}
                    type="text"
                    css={inputStyles.input(!!props.readOnly, props.size)}
                    value={formatText}
                    onChange={handleChange}
                    onPaste={handleChange as unknown as React.ClipboardEventHandler}
                    onBlur={handleBlur}
                />
            </div>
        </Field>
    );
};
